import { BrandLogoEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoUseRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoUseRequestDTO.validationSchema(),
    BrandLogoEntity
  );

  constructor(readonly data: RoomBrandLogoUseRequest) {
    JsonSchemaValidator.assert(RoomBrandLogoUseRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandLogo"],
      properties: {
        roomId,
        brandLogo: {
          instanceof: BrandLogoEntity.name
        }
      }
    };
  }
}

interface RoomBrandLogoUseRequest {
  roomId: RoomId;
  brandLogo: BrandLogoEntity;
}
